import React from 'react';

const DataCenter = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-purple-50/20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div>
              <div className="inline-block">
                <div className="h-1 w-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mb-4"></div>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Data Center Management
              </h2>
            </div>

            <p className="text-lg text-gray-600 leading-relaxed">
              We design Data Centres, from greenfield data center development to the conversion of existing buildings, using the latest technology and adopting the best industry methodologies and best practices to ensure that the infrastructure of the Data Centres meets your requirements.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Our data center consulting team understands the entire lifecycle of the data center, every phase of the data center development and construction process, and can assist in the implementation of the right solutions for your environment and budgets.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Our services, from requirements and design through assessments, optimization, and client representation, are carried out by our in-house specialist data center experts.
            </p>

            <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-xl border border-purple-100">
              <p className="text-sm text-gray-700 leading-relaxed">
                <strong className="text-purple-700">Our Services:</strong> Uninterruptible Power Supply (UPS), Electrical & Power, Cooling System, Fire Detection & Suppression, Builders Work, Raised Access Floor, Data Centre Monitoring System (DCMS), Water Detection and Security & Surveillance System.
              </p>
            </div>
          </div>

          {/* Right Illustration */}
          <div className="relative">
            <div className="relative">
              <img
                src="https://images.pexels.com/photos/4508751/pexels-photo-4508751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Data Center"
                className="w-full h-auto rounded-2xl shadow-xl"
              />
              <div className="absolute -bottom-4 -right-4 w-full h-full border-4 border-purple-500/20 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataCenter;
